/* SK Favorites — pinta la pagina de favoritos con la MISMA card que el slider de la
   home (sk-products). Cada card se renderiza en el servidor (plantilla alternativa
   product.fav-card via /products/{handle}?view=fav-card) para tener metacampos reales
   (sello, precio/kilo, badges) e iconos. El corazon viene activo = quitar de favoritos.
   Carrito y flechas de galeria: mismo comportamiento que el slider home. */
(function () {
  'use strict';

  var grid, empty;

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=fav-card', {
      headers: { Accept: 'text/html' },
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function render() {
    if (!grid) return;
    var list = (window.SKWishlist && window.SKWishlist.read) ? window.SKWishlist.read() : [];
    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.setAttribute('aria-busy', 'true');

    Promise.all(list.map(function (it) { return fetchCard(it.h); })).then(function (cards) {
      grid.innerHTML = cards.join('');
      grid.removeAttribute('aria-busy');

      /* Asegurar estado "guardado" en los corazones (la plantilla ya los marca) */
      grid.querySelectorAll('.sk-fav-btn').forEach(function (b) {
        b.classList.add('is-wishlist');
        b.setAttribute('aria-pressed', 'true');
      });

      /* Si ningun producto se pudo traer, mostrar vacio */
      if (!grid.querySelector('.sk-products__card')) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
      }
    });
  }

  /* --- Flechas de la mini-galeria (mismo comportamiento que el slider home) --- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.sk-products__img-arrow');
    if (!arrow || !arrow.closest('[data-sk-fav-grid]')) return;

    e.preventDefault();
    e.stopPropagation();

    var wrapper = arrow.closest('.sk-products__image-wrapper');
    if (!wrapper) return;

    var imgs = wrapper.querySelectorAll('.sk-products__image');
    if (imgs.length < 2) return;

    var current = 0;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].classList.contains('sk-products__image--active')) { current = i; break; }
    }

    var dir = arrow.classList.contains('sk-products__img-arrow--next') ? 1 : -1;
    var next = (current + dir + imgs.length) % imgs.length;

    imgs[current].classList.remove('sk-products__image--active');
    imgs[next].classList.add('sk-products__image--active');

    var prevBtn = wrapper.querySelector('.sk-products__img-arrow--prev');
    if (prevBtn) prevBtn.classList.toggle('sk-products__img-arrow--hidden', next === 0);
  });

  /* --- Anadir al carrito (mismo patron que el slider home: add + abrir drawer) --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sk-products__action-btn--cart');
    if (!btn || !btn.closest('[data-sk-fav-grid]')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    if (btn.classList.contains('sk-products__action-btn--loading')) return;
    btn.classList.add('sk-products__action-btn--loading');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    var cartItemsComp = document.querySelector('cart-items-component[data-section-id]');
    var sectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';
    if (sectionId) formData.append('sections', sectionId);

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        btn.classList.remove('sk-products__action-btn--loading');
        if (data.status) return;

        btn.classList.add('sk-products__action-btn--added');
        setTimeout(function () { btn.classList.remove('sk-products__action-btn--added'); }, 1500);

        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var counters = document.querySelectorAll('[data-cart-count]');
          for (var c = 0; c < counters.length; c++) counters[c].textContent = cart.item_count;

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, data: { sections: data.sections || {}, itemCount: cart.item_count } },
          }));

          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && drawer.showDialog) drawer.showDialog();
        });
      })
      .catch(function () { btn.classList.remove('sk-products__action-btn--loading'); });
  });

  function init() {
    grid = document.querySelector('[data-sk-fav-grid]');
    empty = document.querySelector('[data-sk-fav-empty]');
    if (!grid) return;
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Al quitar un favorito (el boton .sk-fav-btn dispara el toggle global) re-pintamos */
  document.addEventListener('sk:wishlist:change', render);
  document.addEventListener('shopify:section:load', init);
})();
